import React from 'react';
import './Card.css';

/**
 * Card Component
 *
 * @param {string} variant - 'default' | 'bordered' | 'elevated'
 * @param {string} padding - 'none' | 'sm' | 'md' | 'lg'
 * @param {boolean} hoverable - Add hover effect
 * @param {boolean} clickable - Add cursor pointer
 */
const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  hoverable = false,
  clickable = false,
  className = '',
  onClick,
  ...props
}) => {
  const classNames = [
    'oz-card',
    `oz-card--${variant}`,
    `oz-card--padding-${padding}`,
    hoverable && 'oz-card--hoverable',
    clickable && 'oz-card--clickable',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classNames} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

// Card Header
const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`oz-card__header ${className}`} {...props}>
    {children}
  </div>
);

// Card Title
const CardTitle = ({ children, className = '', ...props }) => (
  <h3 className={`oz-card__title ${className}`} {...props}>
    {children}
  </h3>
);

// Card Description
const CardDescription = ({ children, className = '', ...props }) => (
  <p className={`oz-card__description ${className}`} {...props}>
    {children}
  </p>
);

// Card Content
const CardContent = ({ children, className = '', ...props }) => (
  <div className={`oz-card__content ${className}`} {...props}>
    {children}
  </div>
);

// Card Footer
const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`oz-card__footer ${className}`} {...props}>
    {children}
  </div>
);

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Description = CardDescription;
Card.Content = CardContent;
Card.Footer = CardFooter;

export default Card;
